import { none } from 'fp-ts/Option';
import { Lens, Optional } from 'monocle-ts';
/**
 *  @since 0.0.1
 */
export const Matchers = (tag) => (keys) => {
    const match = (match, def) => (a) => (match[a[tag]] || def)(a);
    const matchLens = (cases) => new Lens((s) => cases[s[tag]].get(s), (a) => (s) => cases[s[tag]].set(a)(s));
    const matchOptional = (cases) => new Optional((s) => {
        const optionalCase = cases[s[tag]];
        return optionalCase !== undefined ? optionalCase.getOption(s) : none;
    }, (a) => (s) => {
        const optionalCase = cases[s[tag]];
        return optionalCase !== undefined ? optionalCase.set(a)(s) : s;
    });
    const transform = (match) => (a) => {
        const c = match[a[tag]];
        return c ? c(a) : a;
    };
    const fold = (a) => a;
    const createReducer = (initialState) => (m, def) => {
        const matcher = match(m, def || ((_a) => (s) => s));
        return (s, a) => {
            const state = s === undefined ? initialState : s;
            return a[tag] in keys ? matcher(a)(state) : state;
        };
    };
    return {
        matchStrict: match,
        match,
        transform,
        fold,
        createReducer,
        createPartialReducer: createReducer,
        strict: (a) => a,
        matchLens,
        matchOptional
    };
};
